import type { DefaultQueryError } from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import {
  hmEstimatePackagesFn,
  type HmEstimatePackagesRequest,
  type HmEstimatePackagesResponse,
} from '@/api/services/hm-estimate-packages-fn';

export const useHmEstimatePackagesMutation = (
  opts?: UseMutationOptions<
    HmEstimatePackagesResponse,
    DefaultQueryError,
    HmEstimatePackagesRequest
  >
) =>
  useMutation<
    HmEstimatePackagesResponse,
    DefaultQueryError,
    HmEstimatePackagesRequest
  >({
    mutationFn: hmEstimatePackagesFn,
    ...opts,
  });
